import {Icon, PriorityIcon} from '@priority-software/priority-style-react';
import React, {useState, useEffect, useRef, forwardRef, useImperativeHandle} from 'react';
import usePortal from 'react-useportal';
import {ButtonWithTooltip} from '../../../../_legacy/FormHeader/components/UniqueScreensHeader';
import {isRTL} from '../../../../Localization';
import {showAnalyticsFeaturePopover} from '../../actions';
import texts from '../../texts';
import styles from '../styles.module.scss';
import {openAnalytics} from '../../../../_shared/GWTBridge/invoke/genPage';
import {sendAnalyticsMonitor} from '../../../../utils/monitoring';
import {monitorTransactionValues} from '../../consts';

export const AnalyticsButton = forwardRef((props, ref) => {
    const [display, setDisplay] = useState<boolean>(true);
    const main = document.getElementsByTagName('main')[0];
    const {Portal} = usePortal({bindTo: main});
    const buttonRef = useRef<HTMLDivElement>();

    useEffect(() => {
        if (buttonRef?.current) {
            setTimeout(() => {
                showAnalyticsFeaturePopover(buttonRef.current);
            }, 2000);
        }
    }, [buttonRef?.current]);

    const toggleShow = (value: boolean) => {
        setDisplay(value);
    };

    useImperativeHandle(ref, () => {
        return {
            toggleShow
        };
    });

    return display ? (
        <Portal>
            <div ref={buttonRef} className={styles.analyticsButtonWrapper}>
                <ButtonWithTooltip
                    position={isRTL() ? 'left center' : 'right center'}
                    tooltip={texts.analyticsToolTip}
                    componentClasses={styles.analyticsButton}
                    size="medium"
                    onClick={() => {
                        sendAnalyticsMonitor(monitorTransactionValues.AnalyticsIcon);
                        openAnalytics();
                    }}
                >
                    <Icon
                        componentClasses={styles.analyticsIcon}
                        iconColor="white"
                        icon={PriorityIcon.graph}
                    />
                </ButtonWithTooltip>
            </div>
        </Portal>
    ) : null;
});
